<template>


  <div class="tabs-container">

    <GridBilantRanduri :BilantID="bilant.ID" @select-bilantrand="onBilantRandSelected" />
    <GridBilantFormule :BilantRandID="selectedBilantRandID" :bilant-data="bilant" />
  </div>
</template>
<script lang="ts">
import GridBilantRanduri from './GridBilantRanduri.vue';
import GridBilantFormule from './GridBilantFormule.vue';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from './../../settings/appSettings';

export default {
  components: {
    GridBilantRanduri,
    GridBilantFormule
  },
  data() {
    return {
      dsBilantFormule: {} as ODataStore,
      dsBilantRanduri: {} as ODataStore,
      selectedIndex: 0,
      selectedRow: null as any,
      selectedBilantRandID: null
    };
  },
  props: {
    bilant: {
      type: Object,
      required: true
    }
  },

  watch: {
    bilant: {
      immediate: true,
      handler(newVal) {
        if (newVal?.BilantID) {
          this.createODataContext(newVal.BilantID);
        }
      },
    },
  },


  methods: {
    createODataContext(BilantID) {
      this.dsBilantRanduri = {
        store: new ODataStore({
          url: AppSetting.API_Url_Contabilitate + 'CON_BilantRanduri',
          key: 'ID',
          version: 4,
          fieldTypes: {
            BilantRandID: "Guid",
            ID: "Guid"
          },
          beforeSend: (e) => {
            e.headers = {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
            };
          },
        }),
        filter: ['BilantID', '=', BilantID]
      };
    },
    onBilantRandSelected(id) {
      this.selectedBilantRandID = id;
    },
  },
};
</script>
<style scoped></style>
